const setupWalkme = (env: string): void => {
  const walkme = document.createElement('script');
  if (env === 'prod' || env === 'sbx') {
    walkme.src =
      'https://cdn.walkme.com/users/e418ca270b8b4a9b8ec59c1cb278f2f7/walkme_e418ca270b8b4a9b8ec59c1cb278f2f7_https.js';
  } else {
    walkme.src =
      'https://cdn.walkme.com/users/e418ca270b8b4a9b8ec59c1cb278f2f7/test/walkme_e418ca270b8b4a9b8ec59c1cb278f2f7_https.js';
  }
  walkme.type = 'text/javascript';
  walkme.async = true;
  const s = document.getElementsByTagName('script')[0];
  s?.parentNode?.insertBefore(walkme, s);
  window._walkmeConfig = { smartLoad: true };
};

export default setupWalkme;
